// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"16":"35eae6e3","238":"56c91f42","773":"10fdcc29"}[chunkId] + ".chunk.css";
};